import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  streamConfigBox: {
    border: '1px solid var(--mui-palette-TableCell-border)',
    borderRadius: '.25rem',
    overflow: 'auto',
    [theme.breakpoints.up('sm')]: {
      height: '12.25rem'
    },
    [theme.breakpoints.up('md')]: {
      height: '12.25rem'
    },
    [theme.breakpoints.up('lg')]: {
      height: '12.05rem'
    },
    [theme.breakpoints.up('xl')]: {
      height: '11.95rem'
    }
  },
  helpTooltip: {
    backgroundColor: theme.vars.palette.background.navigation,
    fontSize: '0.875rem'
  },
  helpTooltipArrow: {
    color: theme.vars.palette.background.navigation
  }
}));

export default useStyles;
